import React from "react";
import Reveal from "@/components/Reveal";
import { COVERS } from "@/data/band";

const STATS = [
  { value: "Decades", label: "On stage professionally" },
  { value: "T in the Park", label: "Original tour alumni" },
  { value: "Thurso → Borders", label: "Sell-out Scottish crowds" },
];

export default function About() {
  return (
    <section id="about" data-testid="about" className="relative py-24 md:py-32 bg-[#0a0a0b] noise-grid">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-7">
            <Reveal>
              <span className="text-sm font-bold uppercase tracking-[0.25em] text-[var(--sb-red)]">The Story</span>
              <h2 className="font-display text-5xl md:text-7xl text-white mt-3 leading-[0.95]">
                Seasoned Players. <br />
                <span className="sb-gradient-text">Pure Adrenaline.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <div className="mt-7 space-y-5 text-white/75 text-lg leading-relaxed">
                <p>
                  Songbird came together over the last few years, but its members have been playing
                  professionally for decades — crafting their unique style in several successful Scottish bands.
                </p>
                <p>
                  A group of talented, established musicians who simply love to play live, they thrive on the
                  adrenaline rush of exhilarating performances. The sound is rooted in rock and alternative,
                  with unmistakable inspiration from pop and dance.
                </p>
                <p>
                  Fronted by a dynamic female singer whose powerful vocals and energetic performances have
                  captivated audiences up and down the country, the band delivers an unforgettable show every
                  time — from intimate venues to grand stages.
                </p>
                <p>
                  Several members were showcased on the original T in the Park tours, travelling the length and
                  breadth of the country to sell-out crowds — from Thurso to the Borders, including intimate
                  gigs on the Scottish islands.
                </p>
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5 space-y-4">
            {STATS.map((s, i) => (
              <Reveal key={s.label} delay={0.1 + i * 0.1}>
                <div className="rounded-2xl border border-white/10 bg-gradient-to-br from-white/[0.06] to-transparent p-6 hover:border-[var(--sb-red)]/40 transition-colors">
                  <div className="font-display text-3xl md:text-4xl text-white">{s.value}</div>
                  <div className="text-white/60 text-sm uppercase tracking-wider mt-1">{s.label}</div>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.4}>
              <div className="rounded-2xl border border-white/10 bg-[#141416] p-6">
                <div className="text-sm font-bold uppercase tracking-[0.2em] text-[var(--sb-amber)] mb-3">
                  The Set List
                </div>
                <p className="text-white/65 text-sm mb-4">
                  Iconic covers reimagined — plus fresh originals on the way.
                </p>
                <div className="flex flex-wrap gap-2">
                  {COVERS.map((c) => (
                    <span
                      key={c}
                      className="text-xs font-semibold uppercase tracking-wider text-white/80 border border-white/15 rounded-full px-3 py-1.5 hover:bg-white/10 transition-colors"
                    >
                      {c}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
